var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('drag-tree', _vm._b({ ref: "tree", staticClass: "menu-sort-tree", attrs: { "props": _vm.defaultProps, "data": _vm.list.sub_category, "default-expanded-keys": _vm.defaultExpandedMap, "auto-expand-parent": false, "allow-drop": _vm.allowDrop, "allow-drag": _vm.allowDrag, "node-visible": _vm.filterNodes, "activeNodeList": _vm.activeNodes }, on: { "node-drop": _vm.handleDrop, "node-drag-start": _vm.handleDragStart, "node-drag-end": _vm.handleDragEnd, "node-drag-over": _vm.handleDragOver, "node-contextmenu": _vm.handleTreeCopyNode, "node-expand": _vm.handleNodeExpand, "node-collapse": _vm.handleNodeExpand, "node-click": _vm.handleCurrentChange }, nativeOn: { "drop": function drop($event) {
        return _vm.handleDragTreeEnd.apply(null, arguments);
      }, "dragover": function dragover($event) {
        $event.preventDefault();
      }, "dragenter": function dragenter($event) {
        return function () {
          _vm.handleDragTreeEnter();
        }.apply(null, arguments);
      } }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
        var node = _ref.node,
            data = _ref.data;
        return _c('div', { staticClass: "custom-tree-node el-tree-node__label", class: {
            'common-playConfig': _vm.isLimitPlayItem(data)
          } }, [_c('node-item', { attrs: { "nodeAllowDrag": _vm.nodeAllowDrag, "isSceneNode": _vm.isSceneNode, "treeName": _vm.treeName, "node": node, "data": data, "sortType": _vm.sortType } })], 1);
      } }]) }, 'drag-tree', _vm.treeProps, false));
};
var staticRenderFns = [];

export { render, staticRenderFns };